import Axios from './APIService';
import { AxiosPromise } from 'axios';
import Tuple from '@/types/Tuple';
import Item from '@/types/Item';

const apiBase = '/data';

const DataAPI = {

    getCharacters(): AxiosPromise<Tuple[]> {
        return Axios.get<Tuple[]>(`${apiBase}/characters`);
    },

    getItems(): AxiosPromise<Item[]> {
        return Axios.get<Item[]>(`${apiBase}/items`);
    }

};

export default DataAPI;
